import angular from 'angular';
import toastr from 'toastr';

angular
  .module('commonServices')
  .factory('flySvc', [
    '$window',
    '$state',
    '$filter',
    '$sce',
    '$timeout',
    '$q',
    'appMessages',
    flySvc,
  ]);

function flySvc($window, $state, $filter, $sce, $timeout, $q, appMessages) {
  var flyArray = [];

  // for messages translated from string (labels)
  var getMessage = appMessages;

  // Options for toastr
  toastr.options.positionClass = 'toast-bottom-right';
  toastr.options.preventDuplicates = true;
  toastr.options.closeButton = true;
  toastr.options.escapeHtml = true;

  // For messages translated from enum exceptionCode
  var getErrorMsg = function(errCode, params, fieldId, type, parametersEnumType) {
    type = type || 'ExceptionCode';
    // for these errorcodes, translate the label of the referenced field
    var fieldLabel;
    if (errCode === 24 || errCode === 25 || errCode === 26 || errCode === 27) {
      fieldLabel = $filter('translateList')(params[0], 'field');
      params[0] = fieldLabel;
    }
    //Add field label to params
    if (!!fieldId && errCode === 3000) {
      params[0] = $filter('translateList')(fieldId, 'field', params[0]);
    }

    // Invoice/credit note template errors. Params come in as language code and are translated into the corresponding full language
    if ((errCode === 1043 || errCode === 1044 || errCode === 1045) && params && params.length > 0) {
      params[0] = $filter('translateList')(params[0].toLowerCase(), 'language', params[0]);
    }

    // For the others, see (with regex) if the param is a guid or a string and translate accordingly
    if (errCode === 9) {
      if (/^\{?[a-fA-F0-9]{8}-([a-fA-F0-9]{4}-){3}[a-fA-F0-9]{12}\}?$/.test(params[0])) {
        fieldLabel = $filter('translateList')(params[0], 'field');
        params[0] = fieldLabel;
      } else {
        fieldLabel = $filter('translate')(params[0]);
        params[0] = fieldLabel;
      }
    }
    //Dates
    if (errCode === 4007) {
      if (params[0]) params[0] = $filter('formatDate')(params[0]);
    }

    if (angular.isArray(params)) {
      //Convert array to object
      params = params.reduce(function(o, v, i) {
        o['p' + i] = parametersEnumType // if the parameters are of a specific enum type, we will translate it accordingly.
          ? Array.isArray(v)
            ? v.map(x => $filter('translateList')(x, parametersEnumType)).join(', ')
            : $filter('translateList')(v, parametersEnumType)
          : v;
        return o;
      }, {});
    }

    var msg;
    if (typeof errCode === 'string' && isNaN(errCode)) {
      msg = getMessage(errCode, params);
      if (!!msg) return msg;
    }
    msg = $filter('translateList')(errCode, type, errCode, params);

    return msg?.toString();
  };

  const handleErrorObject = function(error) {
    const errorCode = error.code >= 0 ? error.code : error.data && error.data.code;
    const params = error.parameters ? error.parameters : error.data && error.data.parameters;
    const type = error.type ? error.type : error.data && error.data.type;
    const parametersEnumType = error.parametersEnumType
      ? error.parametersEnumType
      : error.data && error.data.parametersEnumType;

    toastr.options.onclick = null;
    toastr['error'](
      getErrorMsg(errorCode, params, null, type, parametersEnumType),
      getMessage('ErrorTitle'),
      {
        timeOut: 8000,
      },
    );
  };

  return {
    getFlyArray: function() {
      return flyArray;
    },

    addFly: function(fly) {
      var deferred = $q.defer();
      if (fly) {
        var withheld = [];
        fly.$promise = deferred;
        for (var i = 0; i < flyArray.length; i++) {
          //First remove the other (solo) fly-ins.
          if (fly.solo === true || flyArray[i].solo === true) {
            withheld.push(flyArray[i]);
          }
        }

        for (var j = 0; j < withheld.length; j++) {
          //Remove existing (solo) fly-ins.
          this.removeFly(withheld[j]);
        }

        if (flyArray.length === 2) {
          this.removeFly(flyArray[flyArray.length - 1]);
        }

        flyArray.unshift(fly); //Add object to flyArray and remove it when cycle is round.
        //Vibrate
        if (window.navigator.vibrate) window.navigator.vibrate(500);
      } else {
        deferred.reject();
      }
      return deferred.promise;
    },

    removeFly: function(fly) {
      var index = flyArray.indexOf(fly);
      flyArray.splice(index, 1);
      fly.$promise.resolve(true);
    },

    executeToastrAction: function(state, action, actionLabel, actionParameter) {
      if (typeof action === 'string') {
        state.go(action, actionParameter);
      } else if (typeof action === 'function') {
        $timeout(function() {
          action(actionParameter);
        }, 0);
      }
    },

    action: function(
      title,
      content,
      action,
      actionLabel,
      actionParameter,
      titleParams,
      toastrDisplayMethod,
    ) {
      var fly = this;
      var state = $state;
      toastr.options.onclick = function() {
        fly.executeToastrAction(state, action, getMessage(actionLabel), actionParameter);
      };
      var toastrType = !toastrDisplayMethod ? 'info' : toastrDisplayMethod;
      toastr[toastrType](getMessage(content, titleParams), getMessage(title, titleParams), {
        timeOut: toastrType === 'success' || toastrType === 'info' ? 3000 : 8000,
      });
    },

    proposal: function(title, content, action, actionLabel, actionParameter, titleParams) {
      var fly = this;
      var state = $state;
      toastr.options.onclick = function() {
        fly.executeToastrAction(state, action, getMessage(actionLabel), actionParameter);
      };
      toastr['info'](getMessage(content, titleParams), getMessage(title, titleParams), {
        timeOut: 3000,
      });
    },

    message: function(msgStringOrErrorCode, params, timeout = 3000) {
      // is eigenlijk 'warning'
      var content = null;
      if (typeof msgStringOrErrorCode === 'string')
        content = getMessage(msgStringOrErrorCode, params);
      if (typeof msgStringOrErrorCode === 'number')
        content = getErrorMsg(msgStringOrErrorCode, params);
      toastr.options.onclick = null;
      toastr['info'](content, '', {
        timeOut: timeout,
        extendedTimeOut: timeout,
      });
    },

    error: function(errCode, params, fieldId, type) {
      if (
        typeof errCode === 'object' &&
        (errCode.code >= 0 || (errCode.data && errCode.data.code >= 0))
      )
        return handleErrorObject(errCode);
      if (errCode === 'msgJobFailed') {
        this.action('ErrorTitle', 'msgJobFailed', 'jobs.overview', null, null, null, 'error');
      } else {
        toastr.options.onclick = null;
        toastr['error'](getErrorMsg(errCode, params, fieldId, type), getMessage('ErrorTitle'), {
          timeOut: 8000,
        });
      }
    },

    success: function(content, params) {
      toastr.options.onclick = null;
      if (!content) {
        toastr['success']('', getMessage('SuccessTitle'), {
          timeOut: 3000,
        });
        return;
      }
      toastr['success'](getMessage(content, params), getMessage('SuccessTitle'), {
        timeOut: 3000,
      });
    },

    warning: function(content, params) {
      toastr.options.onclick = null;
      toastr['warning'](getMessage(content, params), getMessage('WarningTitle'), {
        timeOut: 8000,
      });
    },
    info: function(content, params) {
      toastr.options.onclick = null;
      toastr['info'](getMessage(content, params), null, {
        timeOut: 3000,
      });
    },
    changesSaved: function() {
      toastr.options.onclick = null;
      toastr['success'](getMessage('ChangesSaved'), getMessage('SuccessTitle'), {
        timeOut: 3000,
      });
    },

    custom: function({
      toastrType = 'info',
      title = null,
      titleMessage = null,
      titleParams = null,
      content = null,
      contentMessage = null,
      contentParams = null,
      timeOut = null,
      onClick = null,
    }) {
      if (onClick) {
        var fly = this;
        var state = $state;
        toastr.options.onclick = function() {
          fly.executeToastrAction(state, action, getMessage(actionLabel), actionParameter);
        };
        toastr.options.onclick = onClick ?? null;
      } else {
        toastr.options.onclick = null;
      }

      let toastrTitle = null;
      if (titleMessage) {
        toastrTitle = getMessage(titleMessage, titleParams);
      }
      if (!toastrTitle && title) toastrTitle = title;
      let toastrContent = null;
      if (contentMessage) {
        toastrContent = getMessage(contentMessage, contentParams);
      }
      if (!toastrContent && content) toastrContent = content;
      const defaultTimeOut = toastrType === 'success' || toastrType === 'info' ? 3000 : 8000;
      toastr[toastrType](toastrContent, toastrTitle, {
        timeOut: timeOut ?? defaultTimeOut,
      });
    },
    getErrorMsg: getErrorMsg,
  };
}
